var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirectCountSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H11.3125H14C15.1046 1 16 1.89543 16 3V5.5V17C16 18.1046 15.1046 19 14 19H3C1.89543 19 1 18.1046 1 17V3Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4L12.25 4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.3999L12.25 6.3999",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.7998L12.25 8.7998",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 11.2002L12.25 11.2002",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 13.6001L12.25 13.6001",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 16L12.25 16",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.475 7C14.8989 7 12 9.89896 12 13.475C12 17.051 14.8989 19.95 18.475 19.95C19.9475 19.95 21.3052 19.4584 22.393 18.6305L24.5063 20.7437C24.848 21.0854 25.402 21.0854 25.7437 20.7437C26.0854 20.402 26.0854 19.848 25.7437 19.5063L23.6305 17.393C24.4584 16.3052 24.9499 14.9475 24.9499 13.475C24.9499 9.89896 22.051 7 18.475 7ZM13.75 13.475C13.75 10.8655 15.8654 8.75 18.475 8.75C21.0845 8.75 23.1999 10.8655 23.1999 13.475C23.1999 16.0845 21.0845 18.2 18.475 18.2C15.8654 18.2 13.75 16.0845 13.75 13.475Z",
    fill: "#F2B90D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectCountSecondary);
export default __webpack_public_path__ + "static/media/RedirectCountSecondary.10ef6fd41c542e8ffdf979723cc29928.svg";
export { ForwardRef as ReactComponent };